const handleFormCandidate = function () {
  const forms = document.querySelectorAll(
    '.form--candidate:not(.form--candidate-loaded)'
  );
  if (forms.length) {
    forms.forEach((form) => {
      form.classList.add('form--candidate-loaded');
      const fieldToValidate = form.querySelectorAll('.form-field');

      // mozliwosc wybierania kategorii zglaszanej kandydatki - edycja 2024 nie posiada takiej opcji
      // form
      //   .querySelector('[data-id="proposal_category"]')
      //   .closest('fieldset')
      //   .addEventListener('click', function (e) {
      //     const input = this.querySelector('.form-field');
      //     const selectMenu = this.querySelector('.select-menu');
      //     const selectField = this.querySelector('.select-field');
      //     selectMenu.classList.toggle('select-menu--visible');
      //     this.classList.toggle('fieldset--active');
      //     selectMenu.addEventListener('mouseleave', function () {
      //       selectMenu.classList.remove('select-menu--visible');
      //       selectMenu.closest('fieldset').classList.remove('fieldset--active');
      //     });
      //     selectMenu.querySelectorAll('li').forEach((li) => {
      //       li.addEventListener('click', function () {
      //         // console.log(this.innerText);
      //         selectField.innerText = this.innerText;
      //         input.value = this.getAttribute('data-value');
      //         if (
      //           selectMenu.closest('fieldset').classList.contains('has-error')
      //         ) {
      //           selectMenu.closest('fieldset').classList.remove('has-error');
      //         }
      //       });
      //     });
      //   });

      fieldToValidate.forEach((el) => {
        el.addEventListener('input', function () {
          if (el.closest('fieldset').classList.contains('has-error')) {
            validateField(this, 2);
          }
        });
        el.addEventListener('change', function () {
          validateField(this, 2);
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        let formIsValid = true;
        const data = {};

        data['form_placement'] = 'local';

        fieldToValidate.forEach((el) => {
          if (!validateField(el, 2)) {
            formIsValid = false;
          } else {
            data[el.getAttribute('data-id')] = el.value;
          }
        });

        if (formIsValid) {
          createSpinner(form);
          const statsEventLabel = document.location.href;
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: 'site_interaction',
            eventCategory: 'send_form',
            eventAction: 'click',
            eventLabel: statsEventLabel,
          });

          /* FORMULARZ */
          const url = form.getAttribute('data-url');
          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.text())
            .then((html) => {
              const elScroll = form.closest('.article__voting');
              window.scrollTo({
                top:
                  window.pageYOffset +
                  elScroll.getBoundingClientRect().top -
                  170,
                left: 0,
              });
              elScroll.innerHTML = html;
            })
            .catch((err) => console.log('Error', err));

          /* KONIEC FORMULARZA */
        }
      });
    });
  }
};

handleFormCandidate();
